// src/pages/Contact/Contact.tsx
import React, { useState, useEffect, Fragment } from 'react';
import parse from 'html-react-parser';
import styles from './styles.module.sass';
import Page from '../../layouts/Page';
import { hostname } from '../../constants';

interface LocationEntry {
  location: string;
  address: string;
  telephone: string;
  fax?: string;
  email: string;
}

const Contact: React.FC = () => {
  const [locations, setLocations] = useState<LocationEntry[]>([]);

  useEffect(() => {
    fetch(`${hostname}/wp-json/wp/v2/pages/72873`)
      .then(res => res.json())
      .then(data => setLocations(data.acf.location || []))
      .catch(console.error);
  }, []);

  return (
    <Page className={styles.base}>
      <ul className={styles.list}>
        {locations.map(inn => (
          <li key={inn.location} className={styles.footer__item}>
            <h3 className={styles.countryName}>{inn.location}</h3>
            <div>{parse(inn.address)}</div>
            <p>
              Tel: {inn.telephone}
              {inn.fax && <Fragment> | Fax: {inn.fax}</Fragment>}
              <br />
              Email: <a href={`mailto:${inn.email}`}>{inn.email}</a>
            </p>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export default Contact;
